export default __webpack_public_path__ + "static/media/pix.119f6875.svg";